var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"back-to-top","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"back-to-top-button",class:{ 'is-visible': _vm.isVisible },style:({ 
        '--button-size': _vm.size + 'px',
        '--button-bg': _vm.backgroundColor,
        '--button-hover-bg': _vm.hoverBackgroundColor,
        '--button-color': _vm.textColor,
        '--position-right': _vm.positionRight + 'px',
        '--position-bottom': _vm.positionBottom + 'px'
      }),attrs:{"title":_vm.tooltip},on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"back-to-top-icon"},[_vm._t("icon",function(){return [_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"}})])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }